import { render, staticRenderFns } from "./confirm-pay.vue?vue&type=template&id=1f03e8e2&scoped=true"
import script from "./confirm-pay.vue?vue&type=script&lang=js"
export * from "./confirm-pay.vue?vue&type=script&lang=js"
import style0 from "./confirm-pay.vue?vue&type=style&index=0&id=1f03e8e2&prod&lang=scss"
import style1 from "./confirm-pay.vue?vue&type=style&index=1&id=1f03e8e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f03e8e2",
  null
  
)

export default component.exports